export function trackGoogleAdsConversion() {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17999887518/SLsUCL_DpIQcEJ75gYdD'
    });
  }
}